<script lang="ts">
  export let size: number = 28;
</script>

<span class="wm" style="--s:{size}px" aria-hidden="true">
  <img src="/elephant-512.png" alt="" width={size} height={size} class="mark" />
  <span class="type"><slot>Linsmart</slot></span>
</span>

<style>
  .wm { display: inline-flex; align-items: center; gap: 10px; }
  .mark {
    width: var(--s);
    height: var(--s);
    object-fit: contain;
    image-rendering: -webkit-optimize-contrast;
  }
  .type {
    font-family: var(--ls-font);
    font-weight: 600;
    font-size: calc(var(--s) * 0.78);
    letter-spacing: -0.02em;
    color: var(--co-ink);
  }
</style>
